import ArticleInterface from '@app/Interface/ArticleInterface';
import { Button, Card, CardBody, CardFooter, CardHeader, Label, PageSection, Title } from '@patternfly/react-core';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { InfoCircleIcon } from '@patternfly/react-icons';
import ArticleHelper from '@app/Service/ArticleHelper';
import htmlParser from '@app/utils/htmlParser';

interface ArticleItemDetailProps {
    article: ArticleInterface,
    path: string,
    categoryFilter: string
}

const ArticleItemDetail: React.FC<ArticleItemDetailProps> = ({ article, path, categoryFilter }) => {

    return (

        <PageSection>
            <div>
                <Link to={{ pathname: path, search: `?cat=${categoryFilter}`}}>&lt; Back</Link>
            </div>
            <Title headingLevel="h1" className="pf-u-mb-md">{article.title}</Title>
            <Card className="pf-u-mb-xl">
                {ArticleHelper.isNewArticle(article, 2) &&
                    <CardHeader>
                        <Label variant="outline" color="red" icon={<InfoCircleIcon />}>
                            New!
                        </Label>
                    </CardHeader>
                }
                <CardHeader>
                    {article.date.toDateString()}
                </CardHeader>
                <CardBody>
                    <div className="pf-c-content">
                        {htmlParser.htmlToJSX(article.body ?? '')}
                    </div>
                </CardBody>
                {article.categories &&
                    <CardFooter>
                        <span>Category:</span>
                        {article.categories.map((category, index) => (
                            <Label
                                className="pf-u-mx-xs" 
                                key={index}
                                render={() => (
                                    <Link to={{ pathname: path, search: `?cat=${category.slug}`}}>{category.name}</Link>
                                )}
                            ></Label>
                        ))}
                    </CardFooter>
                }
            </Card>
            <div>
                <Button
                    variant="primary"
                    component={props => <Link {...props} to={{ pathname: path, search: `?cat=${categoryFilter}` }} />}
                >Back to articles</Button>
            </div>
        </PageSection>

    );

}

export default ArticleItemDetail